import { Observable } from "rxjs/internal/Observable";
import { catchError, map } from "rxjs/operators";
import { API_URL } from "../../enums/api.enums";
import HttpClient from "../http-client";
import Utils from "../../utils/base-utils";

export default class AuthorApi {
  static apiURL = API_URL;

  // Lấy danh sách tác giả - API mới không cần query parameters
  static getListAuthor(body?: any): Observable<any> {
    const api = `${AuthorApi.apiURL.HOST}/${this.apiURL.GET_LIST_AUTHOR}`;
    return HttpClient.get(api).pipe(
      map(
        (res) => (res as any) || null,
        catchError((error) => new Observable())
      )
    );
  }

  // Tạo tác giả mới - sử dụng format mới với name, description, birthYear
  static addAuthor(body: any): Observable<any> {
    const finalBodyrequest = {
      name: body.name,                    // Tên đầy đủ
      description: body.description,      // Mô tả tác giả (tùy chọn)
      birthYear: body.birthYear          // Năm sinh (tùy chọn)
    };
    // Loại bỏ các trường undefined
    Object.keys(finalBodyrequest).forEach(key => 
      (finalBodyrequest as any)[key] === undefined && delete (finalBodyrequest as any)[key]
    );
    
    const api = `${AuthorApi.apiURL.HOST}/${this.apiURL.ADD_AUTHOR}`;
    return HttpClient.post(api, finalBodyrequest).pipe(
      map(
        (res) => (res as any) || null,
        catchError((error) => new Observable())
      )
    );
  }

  // Lấy danh sách tác giả - public API
  static getAuthor(): Observable<any> {
    const api = `${AuthorApi.apiURL.HOST}/${this.apiURL.GET_AUTHOR}`;
    return HttpClient.get(api).pipe(
      map(
        (res) => (res as any) || null,
        catchError((error) => new Observable())
      )
    );
  }

  // Lấy chi tiết một tác giả
  static getAuthorDetail(id: number): Observable<any> {
    const api = `${AuthorApi.apiURL.HOST}/${this.apiURL.GET_AUTHOR}/${id}`;
    return HttpClient.get(api).pipe(
      map(
        (res) => (res as any) || null,
        catchError((error) => new Observable())
      )
    );
  }

  // Cập nhật tác giả - sử dụng format mới
  static editAuthor(bodyrequest: any): Observable<any> {
    const finalBodyrequest = {
      name: bodyrequest.name,
      description: bodyrequest.description,
      birthYear: bodyrequest.birthYear
    };
    // Loại bỏ các trường undefined
    Object.keys(finalBodyrequest).forEach(key => 
      (finalBodyrequest as any)[key] === undefined && delete (finalBodyrequest as any)[key]
    );
    
    const api = `${AuthorApi.apiURL.HOST}/${this.apiURL.EDIT_AUTHOR}/${bodyrequest.id}`;
    return HttpClient.put(api, finalBodyrequest).pipe(
      map(
        (res) => (res as any) || null,
        catchError((error) => new Observable())
      )
    );
  }

  // Xóa tác giả
  static deleteAuthor(bodyrequest: any): Observable<any> {
    const api = `${AuthorApi.apiURL.HOST}/${this.apiURL.DELETE_AUTHOR}/${bodyrequest.id}`;
    return HttpClient.delete(api).pipe(
      map(
        (res) => (res as any) || null,
        catchError((error) => new Observable())
      )
    );
  }
}
